module.exports = __webpack_public_path__ + "static/media/to-text-loading.159a878a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/to-text-loading.png
// module id = 1956
// module chunks = 6